import { ApolloProvider } from '@apollo/client';
import { getApolloClientInternal } from './apolloClient';

export function wrapInApolloProvider(component: JSX.Element | null): JSX.Element {
    return <ApolloProvider client={getApolloClientInternal()}>{component}</ApolloProvider>;
}
